import PropTypes from 'prop-types';

import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { getBillsIncluded, getListingChips } from '../../../utils/listing';

import { isPlusPlan } from '../../../utils/plans';

import Tag from '../Tag';

import SpotahomeGuaranteeIcon from '../icons/SpotahomeGuaranteeIcon';

import CheckPropertyEyeIcon from '../icons/CheckPropertyEyeIcon';

import styles from './ValuePropositionTags.module.scss';

const ValuePropositionTags = ({
  className = '',
  title,
  securityDepositType,
  isInstantBooking,
  isBestChoice,
  bills,
  plan,
  allowPermanentContract
}) => {
  const classes = classNames(styles['value-propsition-tags'], className);
  const chips = getListingChips(
    securityDepositType === 'noSecurityDeposit',
    isInstantBooking,
    getBillsIncluded(bills),
    isBestChoice,
    isPlusPlan(plan),
    allowPermanentContract
  );
  return (
    <div className={classes}>
      <div className={styles['value-propsition-tags__title']}>{title}</div>
      <div className={styles['value-propsition-tags__content']}>
        {chips.map(chip => (
          <Tag
            colorSchema={chip.colorSchema || 'tag'}
            key={chip.label}
            {...chip}
          />
        ))}
        <Tag
          label={trans('spotahome.guarantee.label').toUpperCase()}
          colorSchema="blue"
          renderLeadingIcon={() => <SpotahomeGuaranteeIcon />}
          isSpaced
        />
        <Tag
          label={trans('check.property.24h.label').toUpperCase()}
          colorSchema="blue"
          renderLeadingIcon={() => <CheckPropertyEyeIcon />}
          isSpaced
        />
      </div>
    </div>
  );
};

ValuePropositionTags.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  securityDepositType: PropTypes.string.isRequired,
  isInstantBooking: PropTypes.bool.isRequired,
  isBestChoice: PropTypes.bool.isRequired,
  bills: PropTypes.array.isRequired,
  plan: PropTypes.string.isRequired,
  allowPermanentContract: PropTypes.string.isRequired
};

export default ValuePropositionTags;
